export const UPLOADED_FILE_STORE = 'UPLOADED_FILE_STORE';
export const UPLOADED_FILE_UPDATE = 'UPLOADED_FILE_UPDATE';
export const UPLOADED_FILE_DESTROY = 'UPLOADED_FILE_DESTROY';
export const UPLOADED_FILE_STORE_SUCCESS = 'UPLOADED_FILE_STORE_SUCCESS';




